import { AlertTriangle, Shield } from "lucide-react";

const ResponderRoleReminder = ({ compact = false, className = "" }) => {
  if (compact) {
    return (
      <div className={`bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 ${className}`}>
        <div className="flex items-center gap-2 text-sm">
          <Shield className="w-4 h-4 text-amber-600 flex-shrink-0" />
          <span className="text-amber-800">
            <strong>Peer support only.</strong> Escalate if safety concerns arise.
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-amber-50 border border-amber-200 rounded-lg p-4 ${className}`}>
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
          <Shield className="w-5 h-5 text-amber-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-amber-900 mb-1" style={{ fontFamily: 'Manrope' }}>
            Role Reminder
          </h3>
          <p className="text-sm text-amber-800">
            Your role is to provide <strong>peer support</strong>, not clinical or medical advice.
          </p>
          <div className="flex items-center gap-2 mt-2 text-sm text-amber-700">
            <AlertTriangle className="w-4 h-4" />
            <span><strong>Escalate immediately</strong> if safety concerns arise.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponderRoleReminder;
